'use strict';

export default class MemberViewCtrl {
  constructor($stateParams, $window, MemberSvc, LoaderSvc,
    GrpRoleModalSvc, MemberModalSvc,
    MemModalDeactivateSvc, MemModalReactivateSvc,
    PositionSvc, PositionModalSvc, DatetimeSvc) {
    var that = this;
    this.ctxId = $stateParams.ctxId; // use context group
    this.personId = $stateParams.perId;

    //load member
    function loadMember() {
      LoaderSvc.start();
      that.wasActive = false;
      that.isActive = false;
      MemberSvc.get({groupId: that.ctxId, id: that.personId}).$promise
        .then(function(member) {
          that.member = member;
          // set hasActivePeriod
          for(var g in member.groups) {
            var grp = member.groups[g];

            // set sort id based on hierarchy
            // Altrusa hack: assumes 3 levels, sets root as 0
            switch (grp.group.hierarchyLevel) {
            case 1:
              grp.group.hierarchySort = '0';
              break;
            case 2:
              grp.group.hierarchySort = '0|'
              + grp.group.id.toString().padStart(8, '0');
              break;
            case 3:
              grp.group.hierarchySort = '0|'
              + grp.group.parentId.toString().padStart(8, '0') + '|'
              + grp.group.id.toString().padStart(8, '0');
              break;
            }

            for(var m in grp.membership) {
              var mem = grp.membership[m];
              // set date display
              if(DatetimeSvc.rangeToString(mem).indexOf('Past') >= 0
              || DatetimeSvc.rangeToString(mem).indexOf('Ends Today') >= 0) {
                that.wasActive = true;
                break;
              }
              if(DatetimeSvc.rangeToString(mem).indexOf('Current') >= 0
              && DatetimeSvc.rangeToString(mem).indexOf('Ends Today') === -1) {
                that.isActive = true;
                break;
              }
            }
          }

          LoaderSvc.stop();
        }).catch(function() {
          LoaderSvc.stopError('Error loading member');
        });
    }
    loadMember();

    this.openMembership = function(groups, groupId, personId) {
      MemberModalSvc.open(groups, groupId, personId).then(function() {
        loadMember();
      });
    };

    this.openDeactivate = function() {
      MemModalDeactivateSvc.open(that.ctxId, that.personId).then(function() {
        loadMember();
      });
    };

    this.openReactivate = function() {
      MemModalReactivateSvc.open(that.ctxId, that.personId, that.member.groups)
        .then(function() {
          loadMember();
        });
    };


    this.setPosition = function(pos, groupId, personId) {
      PositionModalSvc.open(pos, groupId, personId).then(function() {
        loadMember();
      });
    };

    // remove positions
    this.removePosition = function(positionId, positionGroupId) {
      var msg = 'Are you sure you want to permanently delete this record? '
      + '(To end date a position, select "Cancel" and "Edit Position" and '
      + 'enter an end date)';
      if($window.confirm(msg)) {
        PositionSvc.delete({groupId: positionGroupId, id: positionId}).$promise
          .then(function() {
          /**
           * TODO: prevent entire reload
           */
            loadMember();
          });
      }
    };

    this.openGrpRole = GrpRoleModalSvc.open;
  }
}

MemberViewCtrl.$inject = [
  '$stateParams',
  '$window',
  'MemberSvc',
  'LoaderSvc',
  'GrpRoleModalSvc',
  'MemberModalSvc',
  'MemModalDeactivateSvc',
  'MemModalReactivateSvc',
  'PositionSvc',
  'PositionModalSvc',
  'DatetimeSvc'
];
